import classNames from 'classnames';
import onClickLinkAppendUrlParams from '@alltrails/seo/utils/onClickLinkAppendUrlParams';
import { useLanguageRegionCode } from '@alltrails/core/hooks/useLanguageRegionCode';
import Image from '@alltrails/core/components/Image';
import styles from './styles.module.scss';

export type ActivityRiverItemProps = {
  url: string;
  imgSrc: string;
  title: string;
  activityUid: string;
};

const VERBOSE_LANGUAGE_REGION_CODES = ['da-DK', 'de-DE', 'nl-NL', 'nb-NO', 'sv-SE'];

const ActivityRiverItem = ({ url, activityUid, imgSrc, title = '' }: ActivityRiverItemProps) => {
  const languageRegionCode = useLanguageRegionCode();

  return (
    <div className={styles.container} data-testid={title}>
      <a href={url} onClick={e => onClickLinkAppendUrlParams(e, { 'a[]': activityUid })}>
        <Image src={imgSrc} className={styles.image} alt={title} loading="lazy" width={178} height={178} />
        <div className={classNames(styles.title, VERBOSE_LANGUAGE_REGION_CODES.includes(languageRegionCode) ? styles.verboseLanguage : '')}>
          {title}
        </div>
      </a>
    </div>
  );
};

export default ActivityRiverItem;
